import { AnalyticsWrapperProps, QalMfeConfig } from '../types';
import {
  getArrPref,
  getBoolArrPref,
  getBoolObjPref,
  getBoolPref,
} from '../utils/helpers';
import { getQbeTrack } from './config';

export const initialProps = ({
  appEnv = '',
  appName = '',
  appPartner = '',
  appVersion = '',
  appType = '',
  appProduct = '',
  initialData = {},
  isAuthenticated = false,
  basePagePath = '',
  shouldReset = false,
  unitTestMode = false,
  enableAdsEngagementTracking = false,
  enableQalInBuiltEngagementTracking = false,
  resetMilestoneFormEngagedDefault = true,
  enableApiStartEvent = true,
  enableMilestonesPersist = false,
  sendPageViewToDynatrace = true,
  enableDynatraceManualPageDetection = false,
  sendQbeTrackMetaKeysToDynatrace = false,
  sendDataLayerKeysToDynatrace = [],
  sendQALErrorsToDynatrace = true,
  bypassPiiCheckKeys = [],
  enableQalMfe = false,
  enableDynatraceMfe = false,
  qalMfeConfig = {
    mfeName: '',
    mfeType: '', // default to mfe
    mfeOrigins: [],
    shellOrigin: '',
    mfeContext: {
      qbeTrack: {
        meta: {},
      },
      rumScript: '',
      gtmContainer: '',
    },
  } as QalMfeConfig,
}: AnalyticsWrapperProps) => {
  const meta = getQbeTrack().meta || {};

  return {
    appEnv: meta.appEnv || appEnv,
    appName: meta.appName || appName,
    appPartner: meta.appPartner || appPartner,
    appVersion: meta.appVersion || appVersion,
    appType: meta.appType || appType,
    appProduct: meta.appProduct || appProduct,
    initialData: meta.initialData || initialData,
    isAuthenticated: getBoolPref(meta.isAuthenticated, isAuthenticated),
    basePagePath: meta.basePagePath || basePagePath,
    shouldReset: getBoolPref(meta.shouldReset, shouldReset),
    unitTestMode: getBoolPref(meta.unitTestMode, unitTestMode),
    enableAdsEngagementTracking: getBoolPref(
      meta.enableAdsEngagementTracking,
      enableAdsEngagementTracking
    ),
    enableQalMfe: getBoolPref(meta.enableQalMfe, enableQalMfe),
    enableQalInBuiltEngagementTracking: getBoolPref(
      meta.enableQalInBuiltEngagementTracking,
      enableQalInBuiltEngagementTracking
    ),
    resetMilestoneFormEngagedDefault: getBoolPref(
      meta.resetMilestoneFormEngagedDefault,
      resetMilestoneFormEngagedDefault
    ),
    enableApiStartEvent: getBoolPref(
      meta.enableApiStartEvent,
      enableApiStartEvent
    ),
    enableMilestonesPersist: getBoolPref(
      meta.enableMilestonesPersist,
      enableMilestonesPersist
    ),
    sendPageViewToDynatrace: getBoolPref(
      meta.sendPageViewToDynatrace,
      sendPageViewToDynatrace
    ),
    enableDynatraceManualPageDetection: getBoolPref(
      meta.enableDynatraceManualPageDetection,
      enableDynatraceManualPageDetection
    ),
    sendQbeTrackMetaKeysToDynatrace: getBoolArrPref(
      meta.sendQbeTrackMetaKeysToDynatrace,
      sendQbeTrackMetaKeysToDynatrace
    ),
    sendDataLayerKeysToDynatrace: getArrPref(
      meta.sendDataLayerKeysToDynatrace,
      sendDataLayerKeysToDynatrace
    ),
    sendQALErrorsToDynatrace: getBoolObjPref(
      meta.sendQALErrorsToDynatrace,
      sendQALErrorsToDynatrace
    ),
    bypassPiiCheckKeys: getArrPref(meta.bypassPiiCheckKeys, bypassPiiCheckKeys),
    qalMfeConfig: {
      mfeName: meta.qalMfeConfig?.mfeName ?? qalMfeConfig.mfeName,
      mfeType: meta.qalMfeConfig?.mfeType ?? qalMfeConfig.mfeType,
      mfeOrigins: meta.qalMfeConfig?.mfeOrigins ?? qalMfeConfig.mfeOrigins,
      shellOrigin: '',
      mfeContext: {
        qbeTrack: {
          meta:
            meta.qalMfeConfig?.mfeContext?.qbeTrack?.meta ??
            qalMfeConfig.mfeContext?.qbeTrack?.meta ??
            {},
        },
        enableDynatraceMfe: getBoolPref(
          meta.enableDynatraceMfe,
          enableDynatraceMfe
        ),
        rumScript:
          meta.qalMfeConfig?.mfeContext?.rumScript ??
          qalMfeConfig.mfeContext?.rumScript ??
          meta.qalMfeConfig?.mfeContext?.dynatraceScript ??
          qalMfeConfig.mfeContext?.dynatraceScript ??
          '',
        gtmContainer:
          meta.qalMfeConfig?.mfeContext?.gtmContainer ??
          qalMfeConfig.mfeContext?.gtmContainer ??
          '',
      },
    },
  };
};
